module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "loading-container"
  }, [_c('img', {
    staticClass: "icon-loading",
    attrs: {
      "src": require("../assets/icons/loading.gif")
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17cb9b9a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppLoading.vue
// module id = 646
// module chunks = 1